import React, { useState, useEffect, memo } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { getAllClassrooms } from "../../../utils/classrooms";
import StyledSelectField from "../../../components/Classroom/StyledSelectField";
import Button from "../../../components/Common/Button";
import MultiSelectDropdown from "../../../components/Classroom/MultiSelectDropdown";
import {cloneLiveClasses} from "../../../utils/liveClasses";

const ImportLiveClassesModal = ({
  isOpen,
  onClose,
  classroomId,
  setIsLoading,
  onSuccess,
}) => {
  const [selectedClassroom, setSelectedClassroom] = useState("");
  const [classroomOptions, setClassroomOptions] = useState([]);
  const [selectedLiveClasses, setSelectedLiveClasses] = useState([])
  const [classroomData, setClassroomData] = useState([]);
  const [liveClassesList, setLiveClassesList] = useState([])
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)

  const onClassroomChangeHandler = (e) => {
    const txt = e?.value;
    setSelectedClassroom(txt);
  };

  const onLiveClassesChangeHandler = (selectedOptions) => {
    setSelectedLiveClasses(selectedOptions.map((option) => option.value))
  };

  useEffect(() => {
    fetchClassrooms();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchClassrooms = async () => {
    try {
      setLoading(true);
      const response = await getAllClassrooms({
        isLiveClassDropDown: 1,
        status: "",
        startDateTime: "",
        endDateTime: "",
        pageNumber: "",
        pageSize: "",
      });

      if (response?.ok && response?.data?.classRooms) {
        const newClassrooms = response?.data?.classRooms;
        const options = newClassrooms?.map((classroom) => ({
          label: classroom?.name,
          value: classroom._id,
        }));
        setClassroomData(newClassrooms);
        setClassroomOptions(options);
      } else {
        toast.error("Failed to fetch classrooms");
      }
    } catch (error) {
      console.error("Error fetching classrooms:", error.message);
      toast.error("Error fetching classrooms");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const classToFind = classroomData.find(
      (room) => room._id === selectedClassroom
    );
    let liveclassOpt = classToFind ? classToFind.liveClasses : [];
    liveclassOpt = liveclassOpt.filter(liveclass => liveclass.status === 'Completed' && liveclass.hasRecordingFile).map((liveclass) => ({
      label: liveclass?.name,
      value: liveclass._id,
    }));
    setLiveClassesList(liveclassOpt);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedClassroom]);

  const handleSave = async (event) => {
    event.preventDefault();
    setSaving(true)
    try {
      const response = await cloneLiveClasses(classroomId, JSON.stringify({
        liveClassIds: selectedLiveClasses
      }), "Live classes cloned successfully");

      if (response?.liveClasses) {
        toast.success("LiveClasses imported successfully");
        if(onSuccess) {
          onSuccess()
        }
      } else {
        toast.error("Liveclasses import failed");
      }
    } catch (error) {
      toast.error("Liveclasses import failed");
      console.error("Error during Liveclasses import:", error);
    } finally {
      setSaving(false)
    }
    setSelectedClassroom("");
    onClose();
  };

  return (
    <Modal show={isOpen} onHide={() => {}} centered>
      <Modal.Header>
        <Modal.Title>Import LiveClasses from a Classroom</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12">
          <StyledSelectField
            label="Choose Classroom"
            value={selectedClassroom}
            onChange={onClassroomChangeHandler}
            optionsList={classroomOptions}
            placeholder="Select..."
            marginBottom={24}
            isLoading={loading}
            disabled={saving}
          />
        </div>
        <div className="col-12">
          <MultiSelectDropdown
            label="Choose Liveclasses"
            value={selectedLiveClasses}
            onChange={onLiveClassesChangeHandler}
            optionsList={liveClassesList}
            placeholder="Select..."
            disabled={saving}
          />
          {selectedClassroom && liveClassesList?.length === 0 && (
            <div className="error">
              No Liveclasses available for this classroom.
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button
          className="px-4"
          style={{
            height: "45px",
            width: "112px",
            borderRadius: "5px",
            backgroundColor: "white",
            border: "1px solid gray",
            color: "rgb(110, 116, 133)",
            fontFamily: "inherit",
            fontSize: "18px",
          }}
          onClick={onClose}
          disabled={saving}
        >
          Cancel
        </Button>
        <Button className="px-4 save-btn" type="submit" onClick={handleSave} disabled={saving}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default memo(ImportLiveClassesModal);
